import NonProfitOrganizationList from '@/components/npo/NonProfitOrganizationsList';
import { useScrollListener } from '@/hooks/useScrollListener';

const Charities = () => {
  const { scrollEnabled, scrollHandler } = useScrollListener();

  return <NonProfitOrganizationList npoType="CHARITIES" onScroll={scrollHandler} scrollEnabled={scrollEnabled} />;
};

export default Charities;
